import { mountLossContour } from './js/loss-contour-renderer.js';

const hero = document.querySelector('.wireframe-hero');
if (hero) mountLossContour(hero);
